export default __webpack_public_path__ + "static/media/stats-illustration.89e20edc.svg";